// Единая точка для замены публичных данных сайта.
// В contacts.js контактов сейчас нет, поэтому здесь безопасные значения-заглушки.
export const contacts = {
  email: 'alimzhan.gabit4@gmail.com',
  phone: '+7 775 402 90 48',
  phoneHref: '+77754029048',
  whatsapp: 'https://wa.me/77754029048',
  telegram: 'https://t.me/ycat126',
  location: 'Алматы, Казахстан',
};

// Меняйте только url - кнопки в портфолио возьмут новые адреса автоматически.
export const portfolioLinks = {
  carrent: 'https://car-rent-new.alimzhan-gabit4.workers.dev/',
  cleanon: 'https://cleaning-3-site.alimzhan-gabit4.workers.dev/',
  kelinkapro: 'https://cleaning-site-new.alimzhan-gabit4.workers.dev/',
};
